interface ProfilePopupProps {
  open: boolean
  onClose: () => void
  userName: string
  userRole?: string
  userInitials: string
  theme: 'dark' | 'light'
  onToggleTheme: () => void
  onLogOut: () => void
}

export function ProfilePopup({
  open, onClose, userName, userRole = '', userInitials,
  theme, onToggleTheme, onLogOut,
}: ProfilePopupProps) {
  if (!open) return null

  return (
    <>
      <div className="pp-backdrop" onClick={onClose} aria-hidden="true" />
      <div className="profile-popup" role="dialog" aria-modal="true" aria-label="Profile">
        <div className="pp-header">
          <div className="pp-av" aria-hidden="true">{userInitials}</div>
          <div>
            <div className="pp-name">{userName}</div>
            {userRole && <div className="pp-role">{userRole}</div>}
          </div>
        </div>
        <div className="pp-body">
          <div className="pp-divider" />
          <div className="pp-toggle-row">
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" style={{ color: 'var(--text-muted)', flexShrink: 0 }}><path d="M7.5 1v1M7.5 13v1M1 7.5h1M13 7.5h1M3.05 3.05l.7.7M11.25 11.25l.7.7M11.25 3.75l-.7.7M3.75 11.25l-.7.7" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/><circle cx="7.5" cy="7.5" r="3" stroke="currentColor" strokeWidth="1.2"/></svg>
            <span className="pp-toggle-label">Dark mode</span>
            <button
              className={`pp-tog${theme === 'light' ? ' light' : ''}`}
              aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
              role="switch"
              aria-checked={theme === 'dark'}
              onClick={onToggleTheme}
            >
              <div className="pp-tog-knob" />
            </button>
          </div>
          <div className="pp-divider" />
          <a className="pp-item" href="#/admin" onClick={onClose}>
            <svg viewBox="0 0 15 15" fill="none" aria-hidden="true">
              <path d="M7.5 1.5l5 2.1v3.7c0 3-2.1 5.8-5 6.7-2.9-.9-5-3.7-5-6.7V3.6l5-2.1z" stroke="currentColor" strokeWidth="1.2" strokeLinejoin="round"/>
              <path d="M5.5 7.6l1.3 1.3 2.8-3" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            Admin
          </a>
          <button className="pp-item danger" onClick={() => { onClose(); onLogOut() }}>
            <svg viewBox="0 0 15 15" fill="none"><path d="M5.5 13H3a1 1 0 01-1-1V3a1 1 0 011-1h2.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/><path d="M10 10l3-2.5L10 5M13 7.5H6" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/></svg>
            Log out
          </button>
        </div>
        <div className="pp-version">AIRA · Beta v0.1</div>
      </div>
    </>
  )
}
